import {
  linkToHelpArticle,
  linkToHelpSection,
  linkToHelpSectionArticle
} from "common/links";
import { regionCodes } from "common/static/regions";

import { linkToAddCoursesWithQueryParams } from "features/dashboard/pages/courses-page/links";
import { isPlurallApp } from "features/plurall";
import { linkToResourceDiscoverOverview } from "features/resource-discover/routes/links";

export function linkToCreateEQGoogleForm(userEmail?: string | null) {
  return `https://docs.google.com/forms/d/e/1FAIpQLScqA4UoeX3PFg4QOtN6E77ynZnxTYgzGbVBWNJcBJQzUTz7lQ/viewform${
    userEmail ? `?emailAddress=${userEmail}` : ""
  }`;
}

export function linkToGetMoreDataBlog() {
  return "https://senecalearning.com/en-GB/blog/apply-for-seneca-school-analytics-slt-support/?utm_source=insightsPage&utm_medium=app&utm_campaign=uk&utm_content=jack-SeptRollout-MoreDataButton";
}

export function linkToInviteParentsPage(locale: string) {
  return linkToHelpSectionArticle(locale, "4135222");
}

export function linkToSchoolLeaderboardTestBlog() {
  return "https://www.senecalearning.com/blog/%F0%9F%8F%86%F0%9F%8F%86-real-time-school-leaderboards-%F0%9F%8F%86%F0%9F%8F%86/";
}

export function linkToFreePostersFolder() {
  return "https://drive.google.com/drive/folders/1pFE_NVVVAjEetTlkXupdVqn_LKZCqsQ-";
}

export function linkToCertificates() {
  return "https://drive.google.com/file/d/1UzWnVHYf7tHf3PRQcf3uHIDRJby4Fnmw/view";
}

export function linkToCPDCourse() {
  return "https://app.senecalearning.com/classroom/course/9f6bf15c-23fe-401c-810a-3bc66d761885";
}

export function linkToResourceDiscoverTeacher() {
  return `${linkToResourceDiscoverOverview()}?source=teacherplatform`;
}

export function linkToCPDCoursesByRegion(region: string) {
  switch (region) {
    case regionCodes.GB:
      return linkToAddCoursesWithQueryParams({
        price: "Free",
        "Age Group": "Teacher CPD"
      });

    case regionCodes.US:
      return linkToAddCoursesWithQueryParams({
        standard: "Teacher Professional Development"
      });

    case regionCodes.BR:
      return linkToAddCoursesWithQueryParams({
        Etapa: "Capacitação Profissional"
      });

    case regionCodes.MX:
      return linkToAddCoursesWithQueryParams({
        Nivel: "Capacitación profesional"
      });

    case regionCodes.AT:
      return linkToAddCoursesWithQueryParams({
        Schulstufe: "Lehrer-Fortbildung"
      });

    default:
      return "";
  }
}

// Temporary replacement till translations are done
export function linkToSchoolPremiumDescription() {
  return linkToHelpSection(); // return `${linkToHelpSection()}/articles/3103554-premium-school-plans`;
}

export function linkToTeacherHelpSection(locale: string) {
  return `${linkToHelpSection(locale)}/collections/1433506-teacher-faqs`;
}

export function linkToClassSetUpHelp(locale: string) {
  return `${linkToHelpSection(
    locale
  )}/articles/3379119-setting-up-a-class-after-creating-it`;
}

export function linkToSchoolPremiumHelp(locale: string) {
  return linkToHelpSectionArticle(locale, "4066182");
}

export function linkToMailToRichard() {
  return "mailto:richard@seneca.io";
}

export function linkToMISSyncProcessArticle() {
  return linkToHelpArticle({
    article: "5363323-what-is-the-process-for-syncing-my-school-mis-with-seneca"
  });
}

export function linkToSyncingSenecaWithMIS() {
  return linkToHelpSectionArticle("en", "5192508");
}

export function linkToMISInvalidClassSyncs() {
  return linkToHelpSectionArticle(
    "en",
    "5554462-why-aren-t-my-mis-classes-appearing"
  );
}

export function linkToSchoolPremiumBlogWhatsPremium() {
  return "https://senecalearning.com/en-GB/blog/how-can-seneca-premium-benefit-schools/#whats_included_premium";
}

export function linkToSchoolPremiumBlogPremiumCourses() {
  return "https://senecalearning.com/en-GB/blog/how-can-seneca-premium-benefit-schools/#premium_courses";
}

export function linkToSchoolPremiumBlogBookPremiumDemo() {
  return "https://senecalearning.com/en-GB/blog/how-can-seneca-premium-benefit-schools/#book_premium_demo";
}

export function linkToCPDYoutubeChannel(region: string) {
  switch (region) {
    case regionCodes.BR:
      return isPlurallApp()
        ? "https://www.youtube.com/playlist?list=PLtW5dT7Wu-GEGcmFgv7OyTc5l8BD0OZQc"
        : "https://www.youtube.com/c/SenecaEstudos";

    case regionCodes.GB:
    default:
      return "https://www.youtube.com/channel/UCyQwdKOrh0_AmTGqoDhQG5Q";
  }
}

export function linkToNewsletter(region: string) {
  switch (region) {
    case regionCodes.BR:
      return "https://senecaestudos.substack.com/";

    case regionCodes.GB:
    default:
      return "https://senecalearning.substack.com";
  }
}

export function linkToAIMarkedExamQuestionsArticle() {
  return linkToHelpArticle({
    article: "6536455-ai-marked-exam-questions-for-teachers"
  });
}

export {
  isInTeacherPlatform,
  linkToTeacherDashboard,
  linkToChangeEmail,
  linkToClassOverviewPage,
  linkToTeacherHomepage,
  linkToClassPage,
  linkToInviteStudentsToClassPage,
  linkToClassStudentsPage,
  linkToClassCoursesPage,
  linkToClassAssignmentsPage,
  linkToAssignmentPage,
  linkToClassSettingsPage,
  linkToClassInsightsPage,
  linkToResourcesHub,
  linkToClassesPage,
  linkToPersonalInformation,
  linkToTeacherWhatIsPremiumPage,
  linkToProgress,
  linkToProgressReportModal,
  linkToSchoolPage
} from "./routes/links";
